@if(isVisible()){
<div [id]="navLink.id" class="udex-grid udex-mx-auto udex-mb-32">

  @if(servicePlan?.name){
  <h3 [class.d-sm-none]="hasContentForFeatureSection" class="col-12 text-center udex-mb-16 heading__regular--m ">
    {{ servicePlan.description ? servicePlan.description : servicePlan.name }}
  </h3>
  }

  <div class="d-flex flex-column flex-sm-row justify-content-center">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <dcp-plans-and-pricing-display [bundleTemplate]="bundleTemplate" [priceDisplay]="priceDisplay"
        [ratePlans]="ratePlans" [servicePlan]="servicePlan"
        [showHeadline]="!hasContentForFeatureSection"></dcp-plans-and-pricing-display>
    </div>

    <div class="col-12 col-sm-6">
      <dcp-plans-and-pricing-features
        [commitmentPeriod]="priceDisplayOptions?.hideCommitmentPeriodIdInFeatures ? undefined : commitmentPeriod"
        [includes]="includes" [restrictions]="restrictions" [servicePlan]="servicePlan"
        [bundleTemplate]="bundleTemplate"
        [hasContentForFeatureSection]="hasContentForFeatureSection"></dcp-plans-and-pricing-features>
    </div>
  </div>
</div>
}
